export enum FeatureFlag {
  MaintenanceMode = 'maintenance-mode',
  ActivitiesOverview = 'activities-overview',
  CampaignDashboards = 'campaign-dashboards',
  InternalPartyActivities = 'internal-party-activities',
  AnnounceError = 'announce-error',
  AnnounceWarning = 'announce-warning',
  AnnounceInfo = 'announce-info',
  GoogleAnalytics = 'google-analytics',
}
